// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This is a stateless RESTful web-service for **timetable based public transportation routing** as provided by SBB Journey-Planner applications such as [sbb.ch](https://www.sbb.ch/) or [SBB Mobile App](https://apps.apple.com/ch/app/sbb-mobile/id294855237). The service-contract is restricted to **SBB internal consumers** or **accredited partners** and supports various and enhanced use cases.  ### Before \'Sign up\'  For new consumers: 1. This **service needs official approval** before granting any access, therefore send an e-mail (see \'Contact -> E-Mail\') first with the subject: **Request: Sign Up Journey-Service** 2. Wait for the appropriate response e-mail and fill-in the attached **Questionnaire** and follow further steps given in the response.    ### Approved and \'Signed up\' consumers See **Contact** box * **Homepage** for general infos about the service  * **Developer resources** for specific usage and concepts of Journey-Service  See **Blog** on PRODuction for Release-Notes.  Remark: * Please read the **Service-Contract** description in Swagger-Doc carefully. * For further questions, send an e-Mail.  
 *
 * The version of the OpenAPI document: 3.20.32.2
 * Contact: journey-service@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GroupReservationStatusEnum } from './GroupReservationStatusEnum';
import {
    GroupReservationStatusEnumFromJSON,
    GroupReservationStatusEnumFromJSONTyped,
    GroupReservationStatusEnumToJSON,
    GroupReservationStatusEnumToJSONTyped,
} from './GroupReservationStatusEnum';
import type { AudienceEnum } from './AudienceEnum';
import {
    AudienceEnumFromJSON,
    AudienceEnumFromJSONTyped,
    AudienceEnumToJSON,
    AudienceEnumToJSONTyped,
} from './AudienceEnum';
import type { PTConnectionLeg } from './PTConnectionLeg';
import {
    PTConnectionLegFromJSON,
    PTConnectionLegFromJSONTyped,
    PTConnectionLegToJSON,
    PTConnectionLegToJSONTyped,
} from './PTConnectionLeg';
import type { PTRideLeg } from './PTRideLeg';
import {
    PTRideLegFromJSON,
    PTRideLegFromJSONTyped,
    PTRideLegToJSON,
    PTRideLegToJSONTyped,
} from './PTRideLeg';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
    AddressToJSONTyped,
} from './Address';
import type { AlternativeModeLeg } from './AlternativeModeLeg';
import {
    AlternativeModeLegFromJSON,
    AlternativeModeLegFromJSONTyped,
    AlternativeModeLegToJSON,
    AlternativeModeLegToJSONTyped,
} from './AlternativeModeLeg';
import type { StopPlaceClassification } from './StopPlaceClassification';
import {
    StopPlaceClassificationFromJSON,
    StopPlaceClassificationFromJSONTyped,
    StopPlaceClassificationToJSON,
    StopPlaceClassificationToJSONTyped,
} from './StopPlaceClassification';
import type { PointOfInterest } from './PointOfInterest';
import {
    PointOfInterestFromJSON,
    PointOfInterestFromJSONTyped,
    PointOfInterestToJSON,
    PointOfInterestToJSONTyped,
} from './PointOfInterest';
import type { EquipmentTypeEnum } from './EquipmentTypeEnum';
import {
    EquipmentTypeEnumFromJSON,
    EquipmentTypeEnumFromJSONTyped,
    EquipmentTypeEnumToJSON,
    EquipmentTypeEnumToJSONTyped,
} from './EquipmentTypeEnum';
import type { AccessLeg } from './AccessLeg';
import {
    AccessLegFromJSON,
    AccessLegFromJSONTyped,
    AccessLegToJSON,
    AccessLegToJSONTyped,
} from './AccessLeg';
import type { PersonalLeg } from './PersonalLeg';
import {
    PersonalLegFromJSON,
    PersonalLegFromJSONTyped,
    PersonalLegToJSON,
    PersonalLegToJSONTyped,
} from './PersonalLeg';

/**
 * OpenApi patch to enforce generation of all dummy-property classes.
 * @export
 * @interface InheritanceResponse
 */
export interface InheritanceResponse {
    /**
     * 
     * @type {Address}
     * @memberof InheritanceResponse
     */
    dummyAddress?: Address;
    /**
     * 
     * @type {PointOfInterest}
     * @memberof InheritanceResponse
     */
    dummyPointOfInterest?: PointOfInterest;
    /**
     * 
     * @type {PTRideLeg}
     * @memberof InheritanceResponse
     */
    dummyPTRideLeg?: PTRideLeg;
    /**
     * 
     * @type {AccessLeg}
     * @memberof InheritanceResponse
     */
    dummyAccessLeg?: AccessLeg;
    /**
     * 
     * @type {PTConnectionLeg}
     * @memberof InheritanceResponse
     */
    dummyPTConnectionLeg?: PTConnectionLeg;
    /**
     * 
     * @type {AlternativeModeLeg}
     * @memberof InheritanceResponse
     */
    dummyAlternativeModeLeg?: AlternativeModeLeg;
    /**
     * 
     * @type {PersonalLeg}
     * @memberof InheritanceResponse
     */
    dummyPersonalLeg?: PersonalLeg;
    /**
     * 
     * @type {AudienceEnum}
     * @memberof InheritanceResponse
     */
    dummyAudienceEnum?: AudienceEnum;
    /**
     * 
     * @type {GroupReservationStatusEnum}
     * @memberof InheritanceResponse
     */
    dummyGroupReservationStatusEnum?: GroupReservationStatusEnum;
    /**
     * 
     * @type {StopPlaceClassification}
     * @memberof InheritanceResponse
     */
    dummyStopPlaceClassification?: StopPlaceClassification;
    /**
     * 
     * @type {EquipmentTypeEnum}
     * @memberof InheritanceResponse
     */
    dummyEquipmentTypeEnum?: EquipmentTypeEnum;
}



/**
 * Check if a given object implements the InheritanceResponse interface.
 */
export function instanceOfInheritanceResponse(value: object): value is InheritanceResponse {
    return true;
}

export function InheritanceResponseFromJSON(json: any): InheritanceResponse {
    return InheritanceResponseFromJSONTyped(json, false);
}

export function InheritanceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InheritanceResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'dummyAddress': json['dummyAddress'] == null ? undefined : AddressFromJSON(json['dummyAddress']),
        'dummyPointOfInterest': json['dummyPointOfInterest'] == null ? undefined : PointOfInterestFromJSON(json['dummyPointOfInterest']),
        'dummyPTRideLeg': json['dummyPTRideLeg'] == null ? undefined : PTRideLegFromJSON(json['dummyPTRideLeg']),
        'dummyAccessLeg': json['dummyAccessLeg'] == null ? undefined : AccessLegFromJSON(json['dummyAccessLeg']),
        'dummyPTConnectionLeg': json['dummyPTConnectionLeg'] == null ? undefined : PTConnectionLegFromJSON(json['dummyPTConnectionLeg']),
        'dummyAlternativeModeLeg': json['dummyAlternativeModeLeg'] == null ? undefined : AlternativeModeLegFromJSON(json['dummyAlternativeModeLeg']),
        'dummyPersonalLeg': json['dummyPersonalLeg'] == null ? undefined : PersonalLegFromJSON(json['dummyPersonalLeg']),
        'dummyAudienceEnum': json['dummyAudienceEnum'] == null ? undefined : AudienceEnumFromJSON(json['dummyAudienceEnum']),
        'dummyGroupReservationStatusEnum': json['dummyGroupReservationStatusEnum'] == null ? undefined : GroupReservationStatusEnumFromJSON(json['dummyGroupReservationStatusEnum']),
        'dummyStopPlaceClassification': json['dummyStopPlaceClassification'] == null ? undefined : StopPlaceClassificationFromJSON(json['dummyStopPlaceClassification']),
        'dummyEquipmentTypeEnum': json['dummyEquipmentTypeEnum'] == null ? undefined : EquipmentTypeEnumFromJSON(json['dummyEquipmentTypeEnum']),
    };
}

  export function InheritanceResponseToJSON(json: any): InheritanceResponse {
      return InheritanceResponseToJSONTyped(json, false);
  }

  export function InheritanceResponseToJSONTyped(value?: InheritanceResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dummyAddress': AddressToJSON(value['dummyAddress']),
        'dummyPointOfInterest': PointOfInterestToJSON(value['dummyPointOfInterest']),
        'dummyPTRideLeg': PTRideLegToJSON(value['dummyPTRideLeg']),
        'dummyAccessLeg': AccessLegToJSON(value['dummyAccessLeg']),
        'dummyPTConnectionLeg': PTConnectionLegToJSON(value['dummyPTConnectionLeg']),
        'dummyAlternativeModeLeg': AlternativeModeLegToJSON(value['dummyAlternativeModeLeg']),
        'dummyPersonalLeg': PersonalLegToJSON(value['dummyPersonalLeg']),
        'dummyAudienceEnum': AudienceEnumToJSON(value['dummyAudienceEnum']),
        'dummyGroupReservationStatusEnum': GroupReservationStatusEnumToJSON(value['dummyGroupReservationStatusEnum']),
        'dummyStopPlaceClassification': StopPlaceClassificationToJSON(value['dummyStopPlaceClassification']),
        'dummyEquipmentTypeEnum': EquipmentTypeEnumToJSON(value['dummyEquipmentTypeEnum']),
    };
}

